import { LitElement, html, css } from 'lit';
import { getWeekLabel, getPreviousWeek, getNextWeek, isCurrentWeek } from '../utils/date.js';

class WeekSelector extends LitElement {
  static properties = {
    weekStart: { type: String, attribute: 'week-start' },
  };

  static styles = css`
    :host { display: block; }
    .container { background: white; border-radius: 0.5rem; box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1); }
    .inner { padding: 1rem 1.5rem; display: flex; align-items: center; justify-content: space-between; }
    button { padding: 0.5rem; color: #6B7280; background: none; border: none; border-radius: 0.5rem; cursor: pointer; }
    button:hover { background: #F3F4F6; }
    .center { text-align: center; }
    h2 { margin: 0; font-size: 1.25rem; font-weight: 600; color: #111827; }
    .current { font-size: 0.875rem; color: #3B82F6; }
    svg { width: 1.5rem; height: 1.5rem; }
  `;

  render() {
    const label = getWeekLabel(this.weekStart);
    const current = isCurrentWeek(this.weekStart);

    return html`
      <div class="container no-print">
        <div class="inner">
          <button @click=${this._prev}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
          </button>
          <div class="center">
            <h2>${label}</h2>
            ${current ? html`<span class="current">Current Week</span>` : ''}
          </div>
          <button @click=${this._next}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
          </button>
        </div>
      </div>
    `;
  }

  _prev() {
    this.weekStart = getPreviousWeek(this.weekStart);
    this.dispatchEvent(new CustomEvent('week-change', { detail: { weekStart: this.weekStart } }));
  }

  _next() {
    this.weekStart = getNextWeek(this.weekStart);
    this.dispatchEvent(new CustomEvent('week-change', { detail: { weekStart: this.weekStart } }));
  }
}

customElements.define('week-selector', WeekSelector);
